import React from 'react';
import NavLinks from '../components/NavLinks';
import TextTranslation from '../components/TextTranslation';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { i18n } = useTranslation();
  return (
    <>
      <div className="flex flex-col lg:flex-row  justify-center lg:justify-between items-center px-24 gap-10 lg:gap-16 footer text-white py-10">
        <div className="w-auto lg:w-[30%]">
          <span className="block font-bold text-center lg:text-left text-[24px] lg:text-[32px] text-white">
            {i18n.language == 'ar' ? (
              <>
                <TextTranslation>Gemeinschaft</TextTranslation>{' '}
                <TextTranslation>Die Deutsch-Arabische</TextTranslation>
              </>
            ) : (
              <>
                <TextTranslation>Die Deutsch-Arabische</TextTranslation>{' '}
                <TextTranslation>Gemeinschaft</TextTranslation>
              </>
            )}
          </span>
          <div className="flex mt-3 gap-4 justify-between w-full lg:w-1/3">
            <a href="" target="_blank">
              <img src="/Iconface.svg" />
            </a>

            <a href="" target="_blank">
              <img src="/Iconinsta.svg" />
            </a>

            <a href="" target="_blank">
              <img src="/Iconlink.svg" />
            </a>

            <a href="" target="_blank">
              <img src="/Iconyt.svg" />
            </a>
          </div>
        </div>
        <div className="flex flex-wrap w-fit h-fit flex-1 justify-between gap-12">
          <NavLinks mode="footer" isMobileScreen={false} noLang />
        </div>
        <div>
          <div className="text-center md:text-left text-sm">
            <div>
              <span className="font-bold block">
                <TextTranslation>Präsident des Vereins</TextTranslation>
              </span>
              <span className="block">
                Dr. Jalal Barout Tel. 0049/1608350767
              </span>
            </div>
            <div>
              <span className="font-bold block">
                <TextTranslation>Vizepräsident</TextTranslation>{' '}
              </span>
              <span className="block">Mohamed Mousa</span>
            </div>
            <div>
              <span className="font-bold block">
                <TextTranslation>Postanschrift</TextTranslation>
              </span>
              <span className="block">
                Johann-Herrmann-straße 1 <br />
                97078 Würzburg
              </span>
            </div>

            <div>
              <span className="font-bold block">
                <TextTranslation>E-Mail</TextTranslation>
              </span>
              <span className="block">d.a.gemeinschaft@gmail.com</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
